export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14803.313587d1.jpg";